import { boardDefEpics } from './boardDef'
import { boardDefsLoadEpic, boardDefsLoadFailureEpic } from './boardDefs'
import {
  commentAddEpic,
  commentLoadEpic,
  commentLoadFailureEpic,
  commentMapEpic,
  commentAddFailureEpic,
  commentDeleteEpic,
  commentDeleteSuccessEpic,
  commentDeleteFailureEpic
} from './comments'
import {
  tasksLoadEpic,
  tasksLoadFailureEpic,
  taskMoveEpic,
  taskMovePersistEpic,
  taskMovePersistFailureEpic,
  taskDeleteEpic,
  taskDeleteSuccessEpic,
  taskDeleteFailureEpic
} from './tasks'
import {
  taskLinksLoadEpic,
  taskLinksLoadFailureEpic,
  taskLinkAddEpic,
  taskLinkAddFailureEpic,
  taskLinksDeleteLinkEpic,
  taskLinksDeleteLinkSuccessEpic,
  taskLinksDeleteLinkFailureEpic
} from './taskLinks'
import {
  taskChecklistItemsLoadEpic,
  taskChecklistItemsLoadFailureEpic,
  taskChecklistItemMoveEpic,
  taskChecklistItemMoveFailureEpic,
  taskChecklistItemsAddEpic,
  taskChecklistItemsAddFailureEpic,
  taskChecklistItemsUpdateEpic,
  taskChecklistItemsUpdateFailureEpic,
  taskChecklistItemsSaveEpic,
  taskChecklistItemsDeleteEpic,
  taskChecklistItemsDeleteFailureEpic,
  taskChecklistItemsRemoveEpic
} from './taskChecklistItems'
import { projectLoadEpic, projectLoadFailureEpic } from './project'
import { projectMembersLoadEpic, projectMembersLoadFailureEpic } from './projectMembers'
import { combineEpics } from 'redux-observable'
import { feedbackSubmitEpic, feedbackSubmitSuccessEpic } from './feedback'
import { userInfoLoadEpic, langaugeLoadEpic } from './userinfo'
import { tokenRevokeEpic, tokenLoadEpic, tokenUpdateEpic } from './authorization'
import { taskAddSaveEpic, taskAddSaveFailureEpic } from './addTask'
import { taskFieldSaveEpic } from './taskFields'
import { configLoadEpic } from './config'
import { editorLoadEpic } from './editor'
import { resourcesLoadEpic } from './resources'
import { redirectToNotFoundEpic } from './redirectToNotFound'
import { redirectToErrorEpic } from './redirectToError'

export const rootEpic = combineEpics(
  boardDefEpics,
  boardDefsLoadEpic,
  boardDefsLoadFailureEpic,
  commentAddEpic,
  commentAddFailureEpic,
  commentDeleteEpic,
  commentDeleteSuccessEpic,
  commentDeleteFailureEpic,
  commentLoadEpic,
  commentLoadFailureEpic,
  commentMapEpic,
  taskLinksLoadEpic,
  taskLinksLoadFailureEpic,
  taskLinkAddEpic,
  taskLinkAddFailureEpic,
  taskLinksDeleteLinkEpic,
  taskLinksDeleteLinkSuccessEpic,
  taskLinksDeleteLinkFailureEpic,
  taskChecklistItemsLoadEpic,
  taskChecklistItemsLoadFailureEpic,
  taskChecklistItemsAddEpic,
  taskChecklistItemsAddFailureEpic,
  taskChecklistItemMoveEpic,
  taskChecklistItemMoveFailureEpic,
  taskChecklistItemsUpdateEpic,
  taskChecklistItemsUpdateFailureEpic,
  taskChecklistItemsSaveEpic,
  taskChecklistItemsDeleteEpic,
  taskChecklistItemsDeleteFailureEpic,
  taskChecklistItemsRemoveEpic,
  feedbackSubmitEpic,
  projectLoadEpic,
  projectLoadFailureEpic,
  projectMembersLoadEpic,
  projectMembersLoadFailureEpic,
  langaugeLoadEpic,
  resourcesLoadEpic,
  taskAddSaveEpic,
  taskAddSaveFailureEpic,
  tasksLoadEpic,
  tasksLoadFailureEpic,
  tokenRevokeEpic,
  tokenLoadEpic,
  tokenUpdateEpic,
  userInfoLoadEpic,
  feedbackSubmitSuccessEpic,
  taskMoveEpic,
  taskMovePersistEpic,
  taskMovePersistFailureEpic,
  taskFieldSaveEpic,
  configLoadEpic,
  taskDeleteEpic,
  taskDeleteSuccessEpic,
  taskDeleteFailureEpic,
  editorLoadEpic,
  redirectToNotFoundEpic,
  redirectToErrorEpic
)



// WEBPACK FOOTER //
// ./src/store/epics.js